import { useCallback, useEffect, useState } from 'react';

import { isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useQueryParam } from 'use-query-params';

import { openMobileAppInfoModal } from 'components/shared/MobileAppInfo';
import { showMobileInfoSelector } from 'store/app/selectors';
import { guestSignInThunk } from 'store/auth/thunks';
import { useCustomPrivacyPolicySelector, privacyPolicyDataSelector } from 'store/privacyPolicy/selectors';

export function useSignIn() {
  const dispatch = useDispatch();
  const { guestPortalId } = useParams();

  const [emailQueryParam, setEmailQueryParam] = useQueryParam('email');
  const [predefinedEmail] = useState(emailQueryParam || undefined);

  const [isChecked, setIsChecked] = useState(false);
  const toggleCheckbox = useCallback(() => {
    setIsChecked(!isChecked);
  }, [isChecked]);

  const useCustomPrivacyPolicy = useSelector(useCustomPrivacyPolicySelector);
  const privacyPolicyData = useSelector(privacyPolicyDataSelector);
  const showMobileInfo = useSelector(showMobileInfoSelector);

  const handleSubmit = useCallback(
    ({ email, password } = {}) => {
      return dispatch(
        guestSignInThunk({
          email,
          password,
          isRulesAccepted: useCustomPrivacyPolicy ? useCustomPrivacyPolicy && isChecked : true,
          guestPortalId,
        }),
      );
    },
    [dispatch, guestPortalId, isChecked, useCustomPrivacyPolicy],
  );

  useEffect(() => {
    if (isNil(emailQueryParam)) {
      return;
    }

    setEmailQueryParam(undefined);
  }, [emailQueryParam, setEmailQueryParam]);

  useEffect(() => {
    if (privacyPolicyData && showMobileInfo) {
      openMobileAppInfoModal(`guest-portals/${guestPortalId}`, true);
    }
  }, [guestPortalId, privacyPolicyData, showMobileInfo]);

  return {
    predefinedEmail,
    isChecked,
    useCustomPrivacyPolicy,
    handleSubmit,
    toggleCheckbox,
  };
}
